import { ACTION_TYPE } from '../redux/actionType';
import { IAppState } from '../redux/IAppState';
import { Action } from 'redux';
import { IKON_MODAL } from './ikonModal';
import { assoc } from '../../language/module';


/**
 * Action to dispatch to dismiss the currently showing modal and clear out its extras from app state. If there isn't
 * a current modal, that doesn't matter, we end up in the same place: no modal.
 */
export const dismissModalAction = () => ({
  type: ACTION_TYPE.DISMISS_MODAL,
});


export const dismissModalReducer = (state: IAppState, action: Action): IAppState => {
  if (action.type !== ACTION_TYPE.DISMISS_MODAL) {
    return state;
  }

  return assoc('currentModal', { type: IKON_MODAL.NONE }, state);
};
